import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { ApiService } from 'app/shared/apis/api.service';
import { ErrorDialogComponent } from 'app/shared/dialogs/error-dialog/error-dialog.component';
import { PermissionService } from 'app/core/services/permission.service';
import { of, switchMap } from 'rxjs';

/** Sobe a árvore de rotas até achar `data.permissions`. */
function resolveRequiredPermissions(route: ActivatedRouteSnapshot): string[] | null {
    let current: ActivatedRouteSnapshot | null = route;
    while (current) {
        const raw = current.data?.['permissions'];
        if (raw != null) {
            return typeof raw === 'string' ? [raw] : raw;
        }
        current = current.parent;
    }
    return null;
}

function denyAccess(router: Router, matDialog: MatDialog) {
    matDialog.open(ErrorDialogComponent, {
        data: {
            message: 'Você não tem acesso a esta funcionalidade.',
        },
    });
    return of(router.parseUrl('/home'));
}

/**
 * Verifica se o usuário tem todas as permissões necessárias
 */
export const PermissionGuardEvery: CanActivateFn | CanActivateChildFn = (route) => {
    const router = inject(Router);
    const matDialog = inject(MatDialog);
    const permissionService = inject(PermissionService);

    const requiredPermissions = resolveRequiredPermissions(route);
    if (!requiredPermissions?.length) {
        return of(true);
    }

    return permissionService.whenReady().pipe(
        switchMap(() => {
            const ok = requiredPermissions.every((code) => permissionService.hasPermission(code));
            return ok ? of(true) : denyAccess(router, matDialog);
        }),
    );
};

/**
 * Verifica se o usuário tem pelo menos uma das permissões necessárias
 */
export const PermissionGuardSome: CanActivateFn | CanActivateChildFn = (route) => {
    const router = inject(Router);
    const matDialog = inject(MatDialog);
    const permissionService = inject(PermissionService);

    const requiredPermissions = resolveRequiredPermissions(route);
    if (!requiredPermissions?.length) {
        return of(true);
    }

    return permissionService.whenReady().pipe(
        switchMap(() => {
            const ok = requiredPermissions.some((code) => permissionService.hasPermission(code));
            return ok ? of(true) : denyAccess(router, matDialog);
        }),
    );
};
